import React from 'react';
import cn from 'classnames';

import styles from './index.module.css';

const CircleLoader = ({ showLoader, className }) => {
  if (!showLoader) {
    return null;
  }

  return (
    <div className={cn(styles.loader, className)}></div>
  )
}

export default CircleLoader
